<template>
	<div style="overflow: hidden;"
		:style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">


		<div v-if="data.config.data && data.config.data.length>0">

			<!-- <el-row v-if="data.config.style==7006||data.config.style==7001 || data.config.style ==7003||data.config.style==7002">
				<el-col :span=24/rowType
					v-for="(item,index) in (data.config.data).slice(0, data.config.style==7003?4:rowType)"
					v-bind:key="'menuItem'+index">

					<div class="menuItem"
						v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? (data.config.imageHeight+'px'):''}">
						<img :src="item.icon">
					</div>
				</el-col>
			</el-row> -->


			<el-row v-if="data.config.style==7001 ">
				<el-col :span=12 v-for="(item,index) in (data.config.data)" v-bind:key="index">

					<div class="menuItem" @click="clickItem(item.path)"
						v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? (data.config.imageHeight+'px'):''}">
						<img :src="item.image">
					</div>
				</el-col>
			</el-row>

			<!-- 一行三个 -->
			<el-row v-if="data.config.style==7002">
				<el-col :span=8 v-for="(item,index) in (data.config.data)" v-bind:key="index">
					<div class="menuItem" @click="clickItem(item.path)"
						v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? (data.config.imageHeight+'px'):''}">
						<img :src="item.image">
					</div>
				</el-col>
			</el-row>

			<!-- 一行一个 -->
			<el-row v-if="data.config.style==7006">
				<el-col :span=24 v-for="(item,index) in (data.config.data)" v-bind:key="index" @click="clickItem(item.path)">
					<div class="menuItem" @click="clickItem(item.path)"
						v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? (data.config.imageHeight+'px'):''}">
						<img :src="item.image">
					</div>
				</el-col>
			</el-row>

			<!-- 1左2右 -->
			<div v-if="data.config.style==7004">
				<el-row>
					<el-col :span=10>
						<div class="menuItem leftMenuItem" @click="clickItem(data.config.data[0].path)"
							v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? (10+ 2* (data.config.imageHeight) +'px'):''}">
							<!-- <label class="labelItem">box1</label> -->
							<img v-if="data.config.data.length > 0" :src="data.config.data[0].image">
						</div>
					</el-col>
					<el-col :span=14>
						<div class="menuItem" @click="clickItem(data.config.data[1].path)"
							v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? (data.config.imageHeight+'px'):''}">
							<!-- <label class="labelItem">box2</label> -->
							<img v-if="data.config.data.length > 1" :src="data.config.data[1].image">
						</div>
						<div class="menuItem" @click="clickItem(data.config.data[2].path)"
							v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? (data.config.imageHeight+'px'):''}">
							<!-- <label class="labelItem">box3</label> -->
							<img v-if="data.config.data.length > 2" :src="data.config.data[2].image">
						</div>
					</el-col>
				</el-row>
			</div>


			<!-- 上一下二 -->
			<div v-if="data.config.style ==7005">
				<el-row>
					<el-col :span=24>
						<div class="menuItem" @click="clickItem(data.config.data[0].path)"
							v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? ( data.config.imageHeight +'px'):''}">
							<!-- <label class="labelItem">box1</label> -->
							<img v-if="data.config.data.length > 1" :src="data.config.data[0].image">
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span=12>
						<div class="menuItem" @click="clickItem(data.config.data[1].path)"
							v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? ( data.config.imageHeight +'px'):''}">
							<!-- <label class="labelItem">box2</label> -->
							<img v-if="data.config.data.length > 1" :src="data.config.data[1].image">
						</div>
					</el-col>
					<el-col :span=12>
						<div class="menuItem" @click="clickItem(data.config.data[2].path)"
							v-bind:style="{background:data.config.cardBgColor ||'',height:data.config.imageHeight? ( data.config.imageHeight +'px'):''}">
							<!-- <label class="labelItem">box3</label> -->
							<img v-if="data.config.data.length > 2" :src="data.config.data[2].image">
						</div>
					</el-col>
				</el-row>
			</div>

		</div>

	</div>
</template>

<script>
	export default {
		name: 'Tpl_Magic',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
		},
		methods: {
      clickItem(path) {
        console.log(path)
        this.$router.push(path)
      },
		}
	};
</script>

<style scoped>
	.navMenuView {
		width: 100%;
		/* background: #E8E8E8; */
		padding: 0;
		padding-top: 0.625rem;
		padding-right: 0.625rem;
		box-sizing: border-box;
	}

	.menuItem {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 0.625rem;
		margin-left: 0.625rem;
		height: 3.125rem;
		overflow: hidden;
		border-radius: 0.25rem;
	}

	.menuItem img {
		width: 100%;
		height: 100%;
	}


	.ymmp_hd {
		height: 40px;
		background: #E8E8E8;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.navTitleLabel {
		font-size: 1rem;
		color: black;
	}


	.leftMenuItem {

		height: 6.875rem;
		/*110px*/
	}

	.labelItem {
		font-size: 0.8125rem;
		width: 2.5rem;
		text-align: center;
		height: 0.9375rem;
		line-height: 0.9375rem;
	}
</style>